import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'language-changer-dialog',
  templateUrl: '../sharedTemplates/language.changer.dialog.html',
})
export class LanguageChangerDialog implements AfterViewInit {
  langDatas;
  langDatasArry = [];
  selectedLang = '';

  constructor(
    public dialogRef: MatDialogRef<LanguageChangerDialog>,
    private _ApiService: ApiService,
    private _UserHelper: UserHelper,
    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService
  ) {}

  noClick(): void {
    this.dialogRef.close();
  }

  okClick(): void {
    this._LocalizationService.changeLang(this.selectedLang);
  }

  selectionChange(x) {
    this._LocalizationService.changeLang(x);
  }

  ngAfterViewInit() {
    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
    this._UiHelper.languageChangerDialogListener.subscribe(x => {
      if (!x) {
        this.dialogRef.close();
      }
    });
  }
}
